import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));

// Function to enable mocking
async function enableMocking() {
  console.log("REACT_APP_APP_ENV:", process.env.REACT_APP_APP_ENV);

  if (process.env.REACT_APP_APP_ENV === "development") {
    const { worker } = await import("./mocks/browser");
    return worker.start();
  }
  return Promise.resolve();
}

// Conditionally enable mocking and render the app
enableMocking().then(() => {
  root.render(
    <React.StrictMode>
      <RouterProvider router={router} />
    </React.StrictMode>
  );
});

reportWebVitals();
